import React, { useState, useEffect, Fragment } from 'react';
import News from './News';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import { BASE_URL } from 'utils/constants';
import translate from 'i18n/translate';
import { useSelector } from 'react-redux';
import { makeSelectLanguage } from 'containers/App/selectors';

const NewsContainer = () => {
  const [lastPageArticles, setLastPageArticles] = useState([]);
  const language = useSelector(makeSelectLanguage());

  useEffect(() => {
    if (language === 'en-us') {
      Axios.get(`${BASE_URL}/api/articles?page=1&en=true`).then(({ data }) => {
        setLastPageArticles(data.data);
      });
    } else {
      Axios.get(`${BASE_URL}/api/articles?page=1`).then(({ data }) => {
        setLastPageArticles(data.data);
      });
    }
  }, [language]);

  return (
    <Fragment>
      <div className="news-container-main goals-box" duration={2}>
        {lastPageArticles.length > 0 && (
          <Fragment>
            <div className="text-box-title">
              <h1>{translate('news')}</h1>
            </div>
            <News
              textLength={100}
              article={lastPageArticles[0]}
              className="mt-5"
            ></News>
            <News textLength={100} article={lastPageArticles[1]}></News>
            <News textLength={100} article={lastPageArticles[2]}></News>
            <News textLength={100} article={lastPageArticles[3]}></News>
            <div className="width100 text-center">
              <Link to={'/articles/'}>
                <h4 className="text-center mt-3 news-container-see-all">
                  {translate('allNews')}
                </h4>
              </Link>
            </div>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

export default NewsContainer;
